import { useEffect, useState, useCallback, useMemo } from 'react';
import { SESSION_STORAGE_KEYS, CACHE_DEFAULTS } from 'legacyfrontend/constants';
import { useFlightContext } from 'legacyfrontend/contexts/FlightDetailsContext';
import { safeSessionStorage } from 'legacyfrontend/helpers/ssr-helper';

const { CACHE_STATUS } = SESSION_STORAGE_KEYS;

export const useRefreshModal = () => {
  const [showRefreshModal, setShowRefreshModal] = useState(false);
  const { expCacheDate } = useFlightContext();
  const [hasExpired, setHasExpired] = useState(false);

  const timeUntilExpiration = useMemo(
    () =>
      expCacheDate
        ? new Date(expCacheDate).getTime() - Date.now()
        : CACHE_DEFAULTS.DEFAULT_EXPIRATION_TIME,
    [expCacheDate]
  );

  // Inicializar el estado del cache
  useEffect(() => {
    if (!safeSessionStorage.getItem(CACHE_STATUS)) {
      safeSessionStorage.setItem(CACHE_STATUS, 'true');
    }
    setHasExpired(false);
  }, [expCacheDate]);

  const handleRefreshConfirm = useCallback((onRefresh) => {
    setShowRefreshModal(false);

    if (onRefresh) {
      safeSessionStorage.setItem(CACHE_STATUS, 'false');
      onRefresh();
    }
  }, []);

  useEffect(() => {
    if (!expCacheDate || hasExpired || timeUntilExpiration <= 0) return;

    const timerId = setTimeout(() => {
      setShowRefreshModal(true);
      setHasExpired(true);
      safeSessionStorage.setItem(CACHE_STATUS, 'false');
    }, timeUntilExpiration);

    return () => {
      clearTimeout(timerId);
    };
  }, [expCacheDate, timeUntilExpiration, hasExpired]);

  return {
    showRefreshModal,
    setShowRefreshModal,
    handleRefreshConfirm,
  };
};
